import { BaseHttpService } from './../../app/shared/base-http/base-http.service';
import { PageOptions } from './../../app/shared/data-table/data-table.interface';
import { Injectable } from '@angular/core';
import { config } from '../../config/config';
import { getEnv } from '../utility';


@Injectable()
export class SourceMaintenanceApiService {
    constructor(private readonly http: BaseHttpService) { }

    public getSources(sourceNameFilter, pageOptions?: PageOptions) {
        pageOptions = pageOptions || {
            page: 0,
            order: 'asc',
            size: 10,
            sort: 'sourceName',
        };

        const params = this.http.generateHttpParams({
            page: pageOptions.page,
            size: pageOptions.size,
            sort: pageOptions.sort,
            order: pageOptions.order,
            sourceNameFilter: sourceNameFilter
         });
        const url = `${config.tprecmApiBaseUrl[getEnv()]}maint/source`;
        return this.http.get(url, { params: params });
    }

    public saveSource(body) {
        return this.http
            .put(`${config.tprecmApiBaseUrl[getEnv()]}maint/source`, body);
    }

    public createSource(body) {
        return this.http
            .post(`${config.tprecmApiBaseUrl[getEnv()]}maint/source`, body);
    }

    public deleteSource(id) {
        return this.http
            .delete(`${config.tprecmApiBaseUrl[getEnv()]}maint/source/${id}`);
    }
}
